import React from 'react';
import { Outlet } from 'react-router-dom';
import { BrandThemeProvider } from '../../contexts/BrandThemeContext';
import { BrandTwoColumnLayout } from '../../Components/BrandTwoColumnLayout/BrandTwoColumnLayout';
import './styles.scss';

const LayoutContent: React.FC = () => (
  <BrandTwoColumnLayout phoneTagline="Une question concernant votre souscription ?">
    <Outlet />
  </BrandTwoColumnLayout>
);

export const Layout: React.FC = () => {
  return (
    <BrandThemeProvider>
      <LayoutContent />
    </BrandThemeProvider>
  );
};
